import {isLargeScreen, isTouchDevice} from "surveylabJsAssets/common/_globals";
import {Tooltip} from 'bootstrap';

class Slider {
    protected sliderElementFocusFlag: boolean = false;
    protected sliderElementSlidingFlag: boolean = false;

    protected initialized: boolean = false;

    public initOnce(): void {
        if (this.initialized) {
            return;
        }
        this.initialized = true;
        const _this = this;

        $(function () {
            /**
             * Threshold to detect vertical scrolling.
             */
            const verticalScrollingThreshold = 6;

            if (isTouchDevice()) {
                // Trigger an event if vertical scrolling is happening on a touch device
                let touchStartY = 0;
                $(this).on('touchstart', function (e) {
                    touchStartY = e.originalEvent.changedTouches[0].pageY;
                });
                $(this).on('touchmove', function (e) {
                    const deltaY = touchStartY - e.originalEvent.changedTouches[0].pageY;
                    if (Math.abs(deltaY) > verticalScrollingThreshold) {
                        $(this).trigger('verticalScrolling');
                    }
                });
            } else {
                $('main').addClass('desktop-device');
            }
        });

        // Adjust the widths of the options, labels and the sliders
        // As of jquery 3, the load event cannot be inside document ready anymore, see https://github.com/jquery/jquery/issues/3194
        $(window).on("load", function () {
            _this.markElementsWithoutItemLabels();
            _this.adjustElements();
            _this.initStickyTableHeaders();

            $(this).on('resize', function () {
                // Don't adjust elements after window resizing immediatly,
                // so that it's not done multiple times, especially in order to
                // fix adjustment problems when changing the orientation on touch devices.
                // @see https://stackoverflow.com/a/13244739
                clearTimeout($.data(this, 'resizeTimer'));
                $.data(this, 'resizeTimer', setTimeout(function () {
                    _this.destroyStickyTableHeaders();
                    _this.adjustElements();
                    _this.initStickyTableHeaders();
                    _this.updateStickyTableHeaders();
                }, 10));
            });


            // Handle slider elements that were previously hidden and are now shown
            $('.slider').each(function () {
                $(this).closest('.survey-element').on('show', function () {
                    _this.destroyStickyTableHeaders();
                    _this.adjustElement($('.outer-table', $(this)));
                    _this.initStickyTableHeaders();
                    _this.updateStickyTableHeaders();
                });
            });

            $(document).on('scroll', function () {
                _this.updateStickyTableHeaders();
            });
        });
    }

    public updateStickyTableHeaders(): void {
        const _this = this;
        _this.updateStickyIntros();
        $('.slider .outer-table').each(function () {
            if (_this.hasMultipleItems($(this))) {
                const $originalHeader = $('> thead:not(.floating-header)', $(this));
                const $floatingHeader = $('> thead.floating-header', $(this));
                const breakpoint = parseInt($floatingHeader.data('breakpoint'));
                const tableBodyHeight = $('> tbody', $(this)).height();
                const tableOffsetTop = $(this).offset().top;
                const scrollTop = $(window).scrollTop();

                if ((scrollTop + breakpoint > tableOffsetTop) &&
                    (scrollTop + breakpoint <= tableOffsetTop + tableBodyHeight)) {
                    $originalHeader.css('visibility', 'hidden');
                    $floatingHeader.css('visibility', 'visible');
                } else {
                    $originalHeader.css('visibility', 'visible');
                    $floatingHeader.css('visibility', 'hidden');
                }
            }
        });
    }

    /**
     * Toggle visibility of original vs cloned wrapper-level sticky intros based on scroll position.
     * Mirrors the thead-clone visibility behaviour in updateStickyTableHeaders().
     */
    protected updateStickyIntros(): void {
        $('.is-sticky-intro').each(function () {
            const $intro = $(this);
            const $clone = $intro.data('clone') as JQuery | undefined;
            if (!$clone || !$clone.length) {
                return;
            }
            const $wrapper = $intro.parent();
            const navHeight = $('nav').height();
            const introHeight = $clone.outerHeight() || 0;
            const introOffsetTop = $intro.offset().top;
            const wrapperBottom = $wrapper.offset().top + $wrapper.outerHeight();
            const scrollTop = $(window).scrollTop();

            if (scrollTop + navHeight > introOffsetTop &&
                scrollTop + navHeight + introHeight <= wrapperBottom) {
                $intro.css('visibility', 'hidden');
                $clone.css('visibility', 'visible');
            } else {
                $intro.css('visibility', 'visible');
                $clone.css('visibility', 'hidden');
            }
        });
    }

    protected markElementsWithoutItemLabels(): void {
        $('.slider .outer-table').each(function () {
            const hasItemLabel = $('.label-column .label:not(.empty-label)', $(this)).length > 0;
            if (!hasItemLabel) {
                $(this).addClass('no-item-labels');
            }
        });
    }

    protected adjustElements(): void {
        const _this = this;
        // Set width and padding
        $('.slider .outer-table').each(function () {
            _this.adjustElement($(this));
        });
    }

    protected adjustElement($outerTable: JQuery): void {
        this.setOptionWidth($outerTable);
        this.setLabelWidth($outerTable);
        this.setSliderPadding($outerTable);
    }

    protected setOptionWidth($outerTable: JQuery): void {
        const sliderOptionWidthLargeScreen = 80; // px
        const $optionsContainer = $('.header-options-row > th', $outerTable);
        const $optionsTable = $('.options-container table', $optionsContainer);
        const $optionsRow = $('tr', $optionsTable);
        const optionsCount = $('.option-column', $optionsRow).length;
        let colWidth: number;
        if (isLargeScreen()) {
            colWidth = sliderOptionWidthLargeScreen;
        } else {
            colWidth = $optionsTable.outerWidth(false) / optionsCount;
        }
        $('.option-column', $optionsRow).each(function () {
            $(this).css('width', colWidth + 'px');
        });
    }

    protected setLabelWidth($outerTable: JQuery): void {
        const $optionsContainer = $('.header-options-row > th', $outerTable);
        const $optionsElement = $('.options-container > div', $outerTable);
        const $optionsTable = $('table', $optionsElement);
        const isSemanticDifferential = $optionsElement.parents('.semantic-differential-slider').length;
        if (isLargeScreen()) {
            $optionsElement.css('margin-left', ''); // Reset
            $optionsElement.css('margin-right', ''); // Reset
            let labelMinWidth = $optionsContainer.outerWidth(false) - $optionsTable.outerWidth(false);
            if (isSemanticDifferential) {
                // width for sematical differential elements
                labelMinWidth = labelMinWidth / 2;
                $optionsElement.css('margin-right', labelMinWidth + 'px');
            }
            $optionsElement.css('margin-left', labelMinWidth + 'px');
            $('.label-column', $outerTable).each(function () {
                $(this).css('min-width', labelMinWidth + 'px');
            });
        } else {
            if (isSemanticDifferential) {
                $optionsElement.css('margin-right', '');
            }
            $optionsElement.css('margin-left', '');
            $('.label-column', $outerTable).each(function () {
                $(this).css('min-width', '');
            });
        }
    }

    protected setSliderPadding($outerTable: JQuery): void {
        const hasNoItemLabels = $outerTable.hasClass('no-item-labels');
        const $optionsElement = $('.options-container > div', $outerTable);
        const $optionsTable = $('table', $optionsElement);
        const $optionsRow = $('tr', $optionsTable);
        const $sliderContainer = $('.slider-column', $outerTable);
        const $firstOptionCell = $('.option-column:first-child', $optionsRow);
        const $lastOptionCell = $('.option-column:last-child', $optionsRow);
        const sliderPaddingLeft = ($firstOptionCell.outerWidth(false) / 2) + 'px';
        const sliderPaddingRight = ($lastOptionCell.outerWidth(false) / 2) + 'px';
        const sliderMinWidth = $optionsElement.outerWidth(false) + 'px';
        $sliderContainer.each(function () {
            $(this).css('min-width', sliderMinWidth);
            $(this).css('padding-left', sliderPaddingLeft);
            $(this).css('padding-right', sliderPaddingRight);
            if (hasNoItemLabels) {
                const optionsTableWidth = $optionsTable.outerWidth(false) + 'px';
                $(this).css('min-width', optionsTableWidth);
            }
        });
    }


    /**
     * Clone table header as floating header.
     * Also clones any wrapper-level sticky intro (.is-sticky-intro) and offsets the table-header clone
     * by the intro height so they stack instead of overlap.
     */
    protected initStickyTableHeaders(): void {
        const _this = this;
        // Init sticky intros first; their height feeds into option-row clone offsets.
        _this.initStickyIntros();
        $('.slider .outer-table').each(function () {
            if (_this.hasMultipleItems($(this))) {
                const $tableHeader = $('> thead', $(this));
                const tableHeaderWidth = $tableHeader.width();
                const optionsTableWidth = $('table', $tableHeader).width();
                const $tableHeaderClone = $tableHeader.before($tableHeader.clone());
                const navHeight = $('nav').height();
                const offsetTop = 1.2 * parseInt($('html').css('font-size'));
                const introOffset = _this.getStickyIntroOffset($(this));
                $tableHeaderClone.addClass('floating-header')
                    .data('breakpoint', navHeight + offsetTop + introOffset) // Breakpoint when sticky header becomes in/active
                    .css({
                        'width': tableHeaderWidth,
                        'top': navHeight + introOffset
                    });
                $('div', $tableHeaderClone).first().css('paddingTop', offsetTop);
                $('table', $tableHeaderClone).css('width', optionsTableWidth);
            }
        });
    }

    /**
     * Clone any element with the .is-sticky-intro marker and pin the clone with position: fixed.
     * Used by plugins (e.g. LikertHorizontalDual) whose intro sits outside the table thead and therefore
     * doesn't get sticky treatment from the thead-cloning path.
     */
    protected initStickyIntros(): void {
        $('.is-sticky-intro').each(function () {
            const $intro = $(this);
            const navHeight = $('nav').height();
            const $clone = $intro.clone();
            $clone.removeAttr('id')
                .addClass('floating-intro')
                .css({
                    'position': 'fixed',
                    'top': navHeight,
                    'left': $intro.offset().left,
                    'width': $intro.outerWidth(),
                    'visibility': 'hidden',
                    'z-index': 999,
                });
            $intro.after($clone);
            $intro.data('clone', $clone);
        });
    }

    /**
     * Height in pixels of a wrapper-level sticky intro that shares scope with the given outer-table.
     * Used to offset the table's floating-header so the intro and options don't overlap when both stick.
     */
    protected getStickyIntroOffset($outerTable: JQuery): number {
        const $stickyIntro = $outerTable.parents().has('> .is-sticky-intro').first().children('.is-sticky-intro').first();
        return $stickyIntro.length ? ($stickyIntro.outerHeight() || 0) : 0;
    }

    protected destroyStickyTableHeaders(): void {
        $('.floating-header').remove();
        $('.floating-intro').remove();
        $('.is-sticky-intro').removeData('clone');
    }

    protected hasMultipleItems($outerTable: JQuery): boolean {
        return $('.item-row', $outerTable).length > 1;
    }

    // end slider base init function

    /**
     * This is a wrapper function to call the slider by one of the two
     * possible namespaces 'bootstrapSlider' or 'slider'.
     *
     * Bootstrap slider automatically uses the namespace 'bootstrapSlider'
     * if the namespace 'slider' is already taken (e.g. in the questionnare
     * overview).
     *
     * @see https://github.com/seiyria/bootstrap-slider#what-if-there-is-already-a-slider-plugin-bound-to-the-jquery-namespace
     */
    public bootstrapSlider(obj: JQuery, args: any[]): any {
        if (typeof obj.bootstrapSlider === "function") {
            // @ts-ignore
            return (<SliderPlugin<JQuery>>obj.bootstrapSlider).apply(obj, args);
        } else {
            return obj.slider.apply(obj, args);
        }
    };

    public setValue(slider: JQuery, value: number): void {
        const $sliderElement = slider.closest('.bootstrap-slider');
        const itemElementID = $sliderElement.data("item-element-id");
        const $inputElement = $('#' + itemElementID, slider.closest('.slider-column'));
        $inputElement.val(value);
        $inputElement.trigger('change');
    };

    public showHandle(slider: JQuery): void {
        const $sliderHandle = $('.min-slider-handle', this.bootstrapSlider(slider, ['getElement']));
        $sliderHandle.css('background-color', '');
        $sliderHandle.css('border-color', '');
        $sliderHandle.css('z-index', '');
    };


    public hideHandle(slider: JQuery): void {
        const $sliderHandle = $('.min-slider-handle', this.bootstrapSlider(slider, ['getElement']));
        $sliderHandle.css('background-color', 'rgba(0, 0, 0, 0)'); // transparent background
        $sliderHandle.css('border-color', 'rgba(0, 0, 0, 0)'); // transparent background
        $sliderHandle.css('z-index', '0');
    };

    public isHandleHidden(slider: JQuery): boolean {
        const handleBackground = $('.min-slider-handle', this.bootstrapSlider(slider, ['getElement'])).css('background-color');
        return handleBackground === 'rgba(0, 0, 0, 0)' || handleBackground === 'transparent';
    };

    public markActiveSliderRow($row: JQuery): void {
        $row.addClass('row-hover');
        $row.removeClass('row-no-hover');
    };

    public unmarkInactiveSliderRow($row: JQuery): void {
        $row.addClass('row-no-hover');
        $row.removeClass('row-hover');
    };

    /**
     * Sets the status whether there is a slider element that is currently sliding (sliding started but has not stopped yet).
     */
    public sliderIsSliding(isSliding: boolean): void {
        this.sliderElementSlidingFlag = isSliding;
    };

    /**
     * Returns whether there is a slider element that is currently sliding (sliding started but has not stopped yet).
     */
    public isSliderSliding(): boolean {
        return this.sliderElementSlidingFlag;
    };

    /**
     * Sets the status whether there is a slider element that has the current focus.
     */
    public sliderHasFocus(hasFocus: boolean): void {
        this.sliderElementFocusFlag = hasFocus;
    };

    /**
     * Returns whether there is a slider element that has the current focus.
     */
    public hasSliderFocus(): boolean {
        return this.sliderElementFocusFlag;
    }

    public hideHandleTooltip(slider: JQuery): void {
        const $sliderHandle = $('.min-slider-handle', this.bootstrapSlider(slider, ['getElement']));
        const tooltip = Tooltip.getInstance($sliderHandle[0]);
        if (tooltip) {
            tooltip.hide();
        }
    }

    /**
     * Mark given slider as active. Mark other sliders as inactive and hide their tooltips.
     *
     */
    public resetMarkingOfSliders(activeElement: Element): void {
        let hasActiveSliderRow = false;
        const _this = this;
        $('.slider .item-row.row-hover').each(function () {
            if ($.contains(this, activeElement)) {
                _this.markActiveSliderRow($(this));
                hasActiveSliderRow = true;
            } else {
                _this.hideHandleTooltip(_this.bootstrapSlider($('.bootstrap-slider', this), []));
                _this.unmarkInactiveSliderRow($(this));
            }
        });
        _this.sliderHasFocus(hasActiveSliderRow);
    }

    public resetOnSwipe(): void {
        $(document).on('verticalScrolling', () => {
            if (!this.isSliderSliding()) {
                // When swiping make sure to hide all tooltips
                $(document)
                    .find($('.min-slider-handle'))
                    .each(function () {
                        const tooltip = Tooltip.getInstance(this);
                        if (tooltip) {
                            tooltip.hide();
                        }
                    });
            }
        }).on('touchend', (e: JQuery.TouchEndEvent) => {
            if (this.hasSliderFocus()) {
                this.resetMarkingOfSliders(e.target);
            }
        });
    }

    public onSlideStart(slider: JQuery, sliderElement: Element, $sliderHandle: JQuery, $sliderRow: JQuery, min: number, value: number): void {
        if (isTouchDevice() && this.hasSliderFocus()) {
            this.resetMarkingOfSliders(sliderElement);
        }
        $sliderHandle.trigger('focus');
        if (this.isHandleHidden(slider)) {
            // Show the handle and trigger change event
            this.showHandle(slider);
            if (min === value) {
                slider.trigger('change');
            }
        }
        if (isTouchDevice()) {
            // Only mark active rows on touch devices.
            // On desktops this works already fine per default.
            this.markActiveSliderRow($sliderRow);
        }
        this.sliderHasFocus(true);
        this.sliderIsSliding(true);
    }
}

export default new Slider();